var angular = require('angular');
var app = angular.module('learn-resources');
/**
 * A centralized URL generation service.
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('UrlLookup', [
  'appConfiguration',
  'Features',
  function (appConfiguration, Features) {
    const viewContentTypesToAngularPath = {
      article: 'articles',
      assessment: 'assessments',
      file: 'files',
      'imported-content': 'imported-content',
      journey: 'journey',
      msw: 'multi-session-workshops',
      presentation: 'presentations',
      scorm: 'scorm',
      survey: 'survey',
      track: 'tracks',
      workshop: 'workshops',
      video: 'videos',
    };

    const viewContentTypesToLearnerPath = {
      article: 'article',
      assessment: 'assessment',
      file: 'file',
      'imported-content': 'imported-content',
      journey: 'journey',
      msw: 'multi-session-workshop',
      presentation: 'presentation',
      scorm: 'scorm',
      survey: 'survey',
      track: 'track',
      workshop: 'workshop',
      video: 'video',
    };

    const createContentTypesToAngularPath = {
      articles: 'articles',
      videos: 'videos',
      files: 'files',
      scorm: 'scorm',
      assessments: 'assessments',
      courses: 'courses',
      tracks: 'tracks',
      'imported-content': 'imported-content',
    }

    const createContentTypesToLearnerPath = {
      articles: 'article',
      videos: 'video',
      files: 'file',
      scorm: 'scorm',
      assessments: 'assessment',
      courses: 'course',
      tracks: 'course/track',
      'imported-content': 'course'
    }

    const ret = {
      dashboard: () => {
        return Features.useExternalLearner() ? '/dashboard' : '#/dashboard/activity';
      },
      explore: () => {
        return Features.useExternalLearner() ? '/explore' : '#/explore';
      },
      people: () => {
        return Features.useExternalLearner() ? '/people' : '#/people';
      },
      login: () => {
        return Features.useExternalLearner() ? '/login' : '#/signin';
      },
      viewContentType: (contentType, id) => {
        return Features.useExternalLearner()
          ? `/${viewContentTypesToLearnerPath[contentType]}/${id}`
          : `#/view/${viewContentTypesToAngularPath[contentType]}s/${id}`;
      },
      viewAdminSettings: (type) => {
        if (Features.useExternalLearner()) {
          if (type === 'application-tokens') {
            return '/admin/developer-tools/api';
          } else if (type === 'theme') {
            return `/admin/theme`
          } else if (type === 'profiles') {
            return '/admin/profiles'
          } else if (type === 'seats') {
            return '/admin/users/seats'
          }  else {
            return `/admin/connect/${type}`;
          }
        }
        
        return `#/overview/settings/${type}`;
      },
      webhooks: () => {
        return Features.useExternalLearner() ? '/admin/developer-tools/webhooks' : '#/overview/settings/api-applications';
      },    
      api: () => {
        return Features.useExternalLearner() ? '/admin/developer-tools/api' : '#/overview/settings/api-applications';
      },
      surveys: () => {
        return Features.useExternalLearner() ? '/admin/surveys' : '#/overview/surveys';
      },
      surveysCreate: () => {
        return Features.useExternalLearner() ? '/admin/surveys/create' : '#/edit/survey';
      },
      editSurvey: (id) => {
        return Features.useExternalLearner() ? `/admin/surveys/edit/${id}` : `#/edit/survey/${id}`;
      },
      hostSurvey: (id) => {
        return Features.useExternalLearner() ? `/admin/surveys/host/${id}` : `#/host/surveys/${id}`;
      },
      badges: () => {
        return Features.useExternalLearner() ? '/admin/badges' : '#/overview/badges';
      },
      badgesCreate: () => {
        return Features.useExternalLearner() ? '/admin/badges/create' : '#/create/badges';
      },
      editBadge: (id) => {
        return Features.useExternalLearner() ? `/admin/badges/edit/${id}` : `#/overview/badges/${id}`;
      },
      assignmentsV2: () => {
        return Features.useAssignmentsV2() ? '/admin/assignments/overview' : '#/overview/assignments';
      },
      workflowsV2: () => {
        return Features.useAssignmentsV2() ? '/admin/assignments/overview' : '#/overview/workflows';
      },
      reports: () => {
        return Features.useExternalLearner() ? '/admin/reports' : '#/overview/reports';
      },
      viewAdminUsers: (type, id) => {
        if (Features.useExternalLearner()) {
          if (type === 'userOverview') {
            return '/admin/users';
          } else if (type === 'addUsersBulk') {
            return '/admin/users/add/bulk'
          } else if (type === 'addUsersSingle') {
            return '/admin/users/add/single'
          } else if (type === 'editUser' && id) {
            return `/admin/users/edit/single/${id}`
          } else if (type === 'suspendedUser' && id) {
            return `/admin/users/suspended/${id}`
          }
        }

        if (type === 'userOverview') {
          return '#/overview/users';
        } else if (type === 'addUsersBulk') {
          return '#/users/add/csv';
        } else if (type === 'addUsersSingle') {
          return '#/users/add';
        } else if (type === 'editUser' && id) {
          return `#/edit/users/${id}`
        } else if (type === 'suspendedUser' && id) {
          return `/suspended/${id}`
        }
      },
      createContentType: (contentType, id) => {
        if (id && id !== 'new') {
          return Features.useExternalLearner()
            ? `/admin/edit/${createContentTypesToLearnerPath[contentType]}/${id}`
            : `#/edit/${createContentTypesToAngularPath[contentType]}/${id}`;
        }

        return Features.useExternalLearner()
          ? `/admin/edit/${createContentTypesToLearnerPath[contentType]}`
          : `#/edit/${createContentTypesToAngularPath[contentType]}`;
      }
    };

    return ret;
  },
]);
